import React from "react";
import Card from "../../shared/Card";
import { AgGridReact } from "ag-grid-react";

function ManifestImages(props) {
  const getRowStyle = (params) => {
    if (params.node.rowIndex % 2 === 1) {
      return { "background-color": "#eaf3f9" };
    }
  };

  return (
    <Card
      cardType="default"
      cardHeader="Manifest Images"
      headerColor="#046B99"
      headerTextColor="white"
      cardBody={
        <div className="">
          <div
            className="manifest-image-table table-responsive"
            style={{ fontSize: "0.9rem" }}
          >
            <AgGridReact
              onGridReady={props.onGridReady}
              enableSorting={true}
              columnDefs={
                props.isRegulator
                  ? props.columnDefsImagesRegulator
                  : props.columnDefsImages
              }
              rowData={props.manifestImages}
              //domLayout={"autoHeight"}
              // rowSelection={'multiple'}
              // multiSortKey={true}
              enableColResize={true}
              getRowStyle={getRowStyle}
              rowClass={"ag-grid-selectable"}
              //overlayNoRowsTemplate={'No Row Found'}
              onFirstDataRendered={props.onFirstDataRendered}
              frameworkComponents={props.frameworkComponents}
            />
          </div>
        </div>
      }
      cardColor="white"
    />
  );
}

export default ManifestImages;
